import {
    createSinglePromise
} from "../utils/loadResources";
import initVersionSdk from "iuap-fe-webhome-versionsdk";
let VersionSdk;

const initWebhomeVersionSdk = async () => {
    const baseURL = window.TNS_BASE_HOST || window.location.origin;
    if (!VersionSdk) {
        if (baseURL.startsWith("file://")) {
            // 如果是file协议，需要获取统一域名，TNS_OFFLINE_HOST 由 MDF 设置
            let newBaseUrl = window.TNS_OFFLINE_HOST || baseURL;
            console.log('[TNE]检测到当前为离线环境baseURL:', newBaseUrl);
            VersionSdk = initVersionSdk({ baseURL: newBaseUrl });
        } else {
            VersionSdk = initVersionSdk({ baseURL });
        }
    } else {
        // 处理外部window变量赋值较晚问题，需要重新赋值调接口
        let newBaseURL = baseURL;
        if (baseURL.startsWith("file://")) {
            newBaseURL = window.TNS_OFFLINE_HOST || baseURL;
        }
        if(VersionSdk.baseURL !== newBaseURL){
            VersionSdk.changeBaseURL(newBaseURL);
        }
    }
};

const mapProviders = (providerJson) => {
    const providers = {};
    const replacePackages = {};
    for (const key in providerJson) {
        if (Object.hasOwnProperty.call(providerJson, key)) {
            const provider = providerJson[key];
            providers[key] = provider.version;
            if (provider.replacePackages && provider.replacePackages.length) {
                replacePackages[key] = provider.replacePackages;
            }
        }
    }
    return {providers, replacePackages, allProviders: providerJson};
}
// 获取CDN信息
async function fetchContextSdk(){
    try{
        initWebhomeVersionSdk()
        let context = await VersionSdk.getCdnHost();
        return context;
    }catch (e) {}
    console.warn('[TNE]注册中心上下文(空)，已降级处理');
    return {};
}

// 获取所有版本信息
async function fetchAllVersionsSdk () {
    try{
        initWebhomeVersionSdk()
        // 返回所有项目信息（mini、is2ndPackge、version、replacePackages）
        const allProjects = await VersionSdk.getAllVersions(true);
        return allProjects;
    }catch (e) {
        console.warn('[TNE]获取注册中心信息失败，已降级处理，不影响使用。',e);
        return {};
    }
}

// 确保并发情况下相同请求生效同一个promise
async function asyncFetchAllProjects(){
    return await createSinglePromise("fetchAllVersionsSdk",()=>fetchAllVersionsSdk());
}

async function fetchProjectVersionsSdk() {
    try{
        initWebhomeVersionSdk()
        // 返回所有项目版本信息（version）
        const projects = await VersionSdk.getAllVersions()
        return projects
    }catch (e) {}
    console.warn('[TNE]注册中心版本信息(空)，已降级处理');
    return {};
}

async function fetchProjectMetaInfoSdk() {
    try{
        initWebhomeVersionSdk()
        // 返回所有项目版本信息（version）
        const projects = await VersionSdk.getTneMeta()
        return projects
    }catch (e) {}
    console.warn('[TNE]注册中心版本信息(空)，已降级处理');
    return {};
}
// 获取TNE二方包信息
async function fetchCacheProviderPackagesSdk(){
    try{
        initWebhomeVersionSdk();
        let allProjects = await asyncFetchAllProjects();
        let tne2ndProjects = {}
        Object.keys(allProjects).forEach((key) => {
            if (allProjects[key]?.is2ndPackge) {
                tne2ndProjects[key] = allProjects[key];
            }
        });
        //let providers = await VersionSdk.getYnfVersions()
        let providers = tne2ndProjects;
        const services = mapProviders(providers);
        return services;
    }catch (e) {
        console.warn('[TNE]获取注册中心信息失败，已降级处理，不影响使用。',e);
        return {};
    }
}
// 通过域名获取CDN信息（适配社会化应用）
async function fetchContextSdkByDomain(domain) {
    try{
        initWebhomeVersionSdk()
        const context = await VersionSdk.getCdnHost(domain);
        return context;
    }catch (e) {
        console.warn('[TNE]注册中心上下文(空)，已降级处理');
        return {};
    }
}
// 通过域名获取全部版本信息（适配社会化应用）
async function fetchAllProjectsByDomain(domain) {
    try{
        initWebhomeVersionSdk();
        const context = await VersionSdk.getAllVersions(true, domain);
        return context;
    }catch (e) {
        console.warn('[TNE]注册中心上下文(空)，已降级处理');
        return {};
    }
}
// 确保并发情况下相同请求生效同一个promise
async function asyncFetchContext(){
    return await createSinglePromise("asyncFetchContext",()=>fetchContextSdk());
}

// 确保并发情况下相同请求生效同一个promise
async function asyncFetchCacheProviderPackages(){
    return await createSinglePromise("asyncFetchCacheProviderPackages",()=>fetchCacheProviderPackagesSdk());
}

// 确保并发情况下相同请求生效同一个promise
async function asyncFetchProjectVersions() {
    return await createSinglePromise("asyncFetchProjectVersions",()=>fetchProjectVersionsSdk());
}

// 确保并发情况下相同请求生效同一个promise
async function asyncFetchContextByDomain(domain) {
    return await createSinglePromise("asyncFetchContextByDomain" + domain,()=>fetchContextSdkByDomain(domain));
}

async function asyncFetchAllProjectsByDomain(domain) {
    return await createSinglePromise("asyncFetchAllProjectsByDomain" + domain,()=>fetchAllProjectsByDomain(domain));
}

// 确保并发情况下相同请求生效同一个promise
async function asyncFetchProjectMetaInfos() {
    return await createSinglePromise("fetchProjectMetaInfos",()=>fetchProjectMetaInfoSdk());
}

export default {
    asyncFetchContext,
    asyncFetchProjectVersions,
    asyncFetchCacheProviderPackages,
    asyncFetchAllProjects,
    asyncFetchAllProjectsByDomain,
    asyncFetchContextByDomain,
    asyncFetchProjectMetaInfos
};
